import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';

import { BaseLayout } from '@/layouts';
const NotFound = lazy(() => import('@/views/NotFound'));
const Home = lazy(() => import('@/views/Home'));

const AppRoutes = () => {
  return (
    <Suspense fallback="Loading...">
      <Routes>
        <Route path="/" element={<BaseLayout />}>
          <Route index element={<Home />} />
          <Route path="404" element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
